import SimulationRound from "../simulationRound/SimulationRound";
import type { SimulationItem } from "./SimulationItem";

/**
 * Creates a virtual simulation round representing the state before the first round.
 * @param simulationItem 
 * @returns 
 */
export function getVirtualStartRound(simulationItem: SimulationItem): SimulationRound {
  return new SimulationRound({
    index: -1,
    startElementValues: { ...simulationItem.startElementValues },
    elementValues: { ...simulationItem.startElementValues },
    startRandomValues: { ...simulationItem.startRandomValues },
    randomValues: { ...simulationItem.startRandomValues },
    actionCounts: {},
    incidentCounts: {},
    triggerCounts: {},
    played: simulationItem.rounds.length > 0,
    totalValue: 0,
    pendingEffects: []
  });
}
